import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';

import { ICICISenderSelect as SENDER_SELECT } from 'Components/Api/SenderAPI';

import { SelectByAccountNumber as SENDER_BY_ACCOUNT_NUMBER } from 'Components/Api/SenderAPI';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';

import { Container, Grid, Paper, Hidden, Box } from '@material-ui/core';
import { SearchByAccountNumber } from './SearchByAccountNumber';
import { Last10Report } from 'Pages/InnerPages/Report/Last10Report';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { MONEY_TRANSFER_CODE } from 'Components/Helper/Messages';
import BeneficiaryList from './BeneficiaryList';
import { useLocation } from 'react-router-dom';

import { PrimaryButton } from 'Components/Inputes/CustomButton';
import SearchIcon from 'Components/SvgButtons/SearchIcon';
import AutoSubmitMobileForSender from 'Components/Helper/AutoSubmitMobileForSender';
import AddbeneficiaryIcon from 'Components/SvgButtons/AddbeneficiaryIcon';
import { CONSUMER_NUMBER_FONT_SIZE } from 'Config';
import HOCLoader from 'Components/Loader/HOCLoader';

const CustomContainer = HOCLoader(Container);

export const SenderSearch = ({ ActiveDMTName }) => {
    const formRef = useRef();
    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    async function fetchConsumerNumberFontSize() {
        setConsumerNumberFontSize(await CONSUMER_NUMBER_FONT_SIZE());
    }
    const location = useLocation();
    const classes = commonStyle();
    const history = useHistory();
    const [senderNo, setSenderNo] = useState('');
    const [senderID, setSenderID] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isSearchByAccount, setIsSearchByAccount] = useState(false);
    const [isSenderDetails, setSenderDetails] = useState(false);
    const [isAfterSenderDetails, setAfterSenderDetails] = useState('none');
    const [severity, setSeverity] = useState('success');
    const [addBeneficiary, setAddBeneficiary] = useState('none');
    const [serviceCode, setServiceCode] = useState(MONEY_TRANSFER_CODE);
    const [SenderList, setSenderList] = useState([]);
    const Mobile = location?.state?.Mobile;

    const [formObject, setFormObject] = useState({
        Mobile: '',
        Name: '',
        SenderID: '',
        RemainingLimit: '',
        Consumed: '',
        isAddBeneficiary: false,
        isSearchAccount: false
    });

    useEffect(() => {
        fetchConsumerNumberFontSize();
        select();
        fetchSender();
        setLoading(false);
    }, []);

    const fetchSender = () => {
        if (formRef === undefined) return;

        if (!formRef.current) return;

        if (formRef.current.values === undefined) return;

        if (formRef.current.values.Mobile === undefined) return;

        if (formRef.current.values.Mobile.length !== 10) return;

        formRef.current.handleSubmit();
    };

    const select = () => {
        let primaryID = Mobile;

        if (primaryID === undefined) return;
        if (primaryID === null) return;

        if (primaryID === 'ICompositeDMT') return;

        if (primaryID.length !== 10) return;

        setFormObject({
            ...formObject,
            Mobile: primaryID,
            Name: '',
            GUID: '',
            RemainingLimit: ''
        });
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setFormObject({
            ...formObject,
            Mobile: values.Mobile,
            Name: '',
            AccountNumber: '',
            SenderID: '',
            Consumed: '',
            RemainingLimit: ''
        });
        setServiceCode('');
        setSenderID('');
        setSenderNo('');
        setResponseMessage('');
        var requestObj = JSON.stringify(values);

        if (values.isAddBeneficiary) {
            var param = {
                Mobile: values.Mobile,
                SenderID: values.SenderID
            };
            history.push('/IC_BeneAdd', param);
            return;
        }

        if (values.isSearchAccount) {
            let param = {
                AccountNumber: values.AccountNumber
            };
            setLoading(true);
            let requestObj = JSON.stringify(param);
            let response = await SENDER_BY_ACCOUNT_NUMBER(requestObj);

            if (!response.isAuthorized) LOGOUT();

            setLoading(false);
            setServiceCode(MONEY_TRANSFER_CODE);
            setSeverity('success');

            let data = JSON.parse(response.data);

            setAddBeneficiary('inline');
            setIsSearchByAccount(true);
            setSenderList(data);
            return;
        }

        setLoading(true);

        var response = await SENDER_SELECT(requestObj);

        if (!response.isAuthorized) LOGOUT();

        setAfterSenderDetails(false);
        setLoading(false);
        setServiceCode(MONEY_TRANSFER_CODE);
        setSeverity('success');

        var param_2 = {
            Mobile: values.Mobile
        };
        if (!response.status) {
            setSeverity('error');
            if (response.data === 'Sender not registered') {
                history.push('/IC_SenderAdd', param_2);
            }

            if (response.data === 'Sender not verified') {
                history.push('/IC_SenderVerify', param_2);
            }
            if (
                response.data ===
                'Your KYC is not approved, please contact to customer care'
            ) {
                history.push('/KycIndex');
                return;
            }

            setIsError(true);
            setResponseMessage(response.data);
            return;
        }
        setSenderDetails(true);

        var data = JSON.parse(response.data);

        setAddBeneficiary('inline');

        setFormObject({
            Mobile: data.Mobile,
            Name: data.Name,
            SenderID: data.SenderID,
            Consumed: data.Consumed,
            RemainingLimit: data.RemainingLimit,
            isAddBeneficiary: false
        });
        setSenderID(data.SenderID);
        setSenderNo(data.Mobile);
        setLoading(false);
    };

    const FormValidationSchema = Yup.object({
        // Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <AutoSubmitMobileForSender />
                            <Grid item xs={12}>
                                <Paper
                                    square={false}
                                    className={classes.PaperStyle}
                                >
                                    {isAfterSenderDetails ? (
                                        <Grid>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={4}
                                                    lg={4}
                                                >
                                                    <MaterialNumberField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Mobile"
                                                        name="Mobile"
                                                        type="Mobile"
                                                        length={10}
                                                        placeholder="Mobile"
                                                        // typed_length={1}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={2}
                                                    lg={2}
                                                >
                                                    <PrimaryButton
                                                        title="Search"
                                                        disabled={loading}
                                                        endIcon={<SearchIcon />}
                                                        onClick={(e) => {
                                                            setFieldValue(
                                                                'isAddBeneficiary',
                                                                false
                                                            );
                                                            setAddBeneficiary(
                                                                'none'
                                                            );
                                                            handleSubmit(e);
                                                        }}
                                                    >
                                                        Search
                                                    </PrimaryButton>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={4}
                                                    lg={4}
                                                >
                                                    <MaterialNumberField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Account Number"
                                                        name="AccountNumber"
                                                        type="AccountNumber"
                                                        length={20}
                                                        placeholder="AccountNumber"
                                                        typed_length={1}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <PrimaryButton
                                                        title="Search By Account"
                                                        disabled={loading}
                                                        endIcon={<SearchIcon />}
                                                        onClick={(e) => {
                                                            setFieldValue(
                                                                'isSearchAccount',
                                                                true
                                                            );
                                                            setAddBeneficiary(
                                                                'none'
                                                            );
                                                            handleSubmit(e);
                                                        }}
                                                    >
                                                        Search By Account
                                                    </PrimaryButton>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    ) : null}
                                    {isSenderDetails ? (
                                        <Grid container spacing={2}>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={3}
                                                lg={3}
                                            >
                                                <MaterialNumberField
                                                    font_size={
                                                        consumerNumberFontSize
                                                    }
                                                    label="Mobile"
                                                    name="Mobile"
                                                    type="text"
                                                    length={10}
                                                    placeholder="Mobile"
                                                    //typed_length={1}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialTextField
                                                    label="Name"
                                                    name="Name"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="Name"
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialTextField
                                                    label="Remaining Limit"
                                                    name="RemainingLimit"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="Remaining Limit"
                                                />
                                                <Hidden xsUp>
                                                    <MaterialTextField
                                                        label="SenderID"
                                                        name="SenderID"
                                                        type="text"
                                                        readOnly={true}
                                                        placeholder="SenderID"
                                                    />
                                                </Hidden>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialTextField
                                                    label="Consumed"
                                                    name="Consumed"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="Consumed"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={3}
                                                lg={3}
                                            >
                                                <Box display={addBeneficiary}>
                                                    <PrimaryButton
                                                        title="Add Bene"
                                                        disabled={loading}
                                                        endIcon={
                                                            <AddbeneficiaryIcon />
                                                        }
                                                        onClick={(e) => {
                                                            setFieldValue(
                                                                'isAddBeneficiary',
                                                                true
                                                            );
                                                            handleSubmit(e);
                                                        }}
                                                    >
                                                        Add Bene
                                                    </PrimaryButton>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    ) : null}
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            />
            {isSearchByAccount ? (
                <SearchByAccountNumber
                    isOpen={isSearchByAccount}
                    title="Sender"
                    request={SenderList}
                    negativeButtonClick={() => {
                        setIsSearchByAccount(false);
                    }}
                />
            ) : null}

            <BeneficiaryList
                senderMobile={senderNo}
                senderName={formObject.Name}
                ActiveDMTName={ActiveDMTName}
                senderID={senderID}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />
            {isAfterSenderDetails ? (
                <Last10Report
                    ServiceID={serviceCode}
                    setIsError={(value) => {
                        setIsError(value);
                    }}
                    setSeverity={(value) => {
                        setSeverity(value);
                    }}
                    setLoading={(value) => {
                        setLoading(value);
                    }}
                    setResponseMessage={(value) => {
                        setResponseMessage(value);
                    }}
                    formRef={formRef}
                />
            ) : null}
        </CustomContainer>
    );
};
